import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import * as wjcSheet from "@grapecity/wijmo.grid.sheet";
import { UtilService } from "../../../services/util.service";
import { v4 as uuidv4 } from 'uuid';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcCore from '@grapecity/wijmo';
import { template } from "ng-block-ui/components/block-ui-content/block-ui-content.component.template";
import { MatDialog } from "@angular/material/dialog";
// import * as wjXlsx from "@grapecity/wijmo.xlsx";
// import * as wjcCore from "@grapecity/wijmo";
// import * as jszip from 'jszip';
// wjXlsx.useJSZip(jszip);


declare let $: any;

@Component({
  selector: "app-excel-viewer",
  templateUrl: "./excel-viewer.component.html",
  styleUrls: ["./excel-viewer.component.scss"],
})
export class ExcelViewerComponent implements OnChanges {
  excelLoadError = '';
  @Input() excelFile: any;
  @Input() isExtractionOutput = false;
  // add output property to emit changes excelFileChanged
  @Output() excelFileChanged = new EventEmitter<any>();
  // workbook: wjXlsx.Workbook;
  // sheetIndex: number;

  @ViewChild("flex") flex: wjcSheet.FlexSheet;
  showLoader = false;
  isFileLoaded = false;
  addNewRowColumns = []
  updatedRows = new Set<number>();  // track updated row indexes
  ngOnChanges(changes: SimpleChanges) {
    if(changes.excelFile && changes.excelFile.currentValue !== changes.excelFile.previousValue) {
      this.excelFile = changes.excelFile.currentValue;
      setTimeout(() => {
        this.loadDataViewer();
      }, 500);
    }
  }

  constructor(private utilService: UtilService, public dialog: MatDialog) {
    this.utilService.updateLeftExcelSheetRow.subscribe((obj) => {
      if(this.flex.hostElement && this.flex.hostElement.dataset && this.flex.hostElement.dataset.uuid != obj.uuid) {
        this.flex.rows.forEach((item) => {
          item.cssClass = '';
        })
        if(this.flex.rows[obj.index-1]) {
          this.flex.rows[obj.index-1].cssClass = 'highlight-row';
          this.flex.scrollIntoView(obj.index-1, 0, true);
        }
      }
    })
  }

  loadDataViewer() {
    this.showLoader = true;
    this.excelLoadError = '';
    const self = this;
    const gridId = 'grid-' + uuidv4(); 
    this.flex.hostElement.setAttribute('data-uuid', gridId);
    this.flex.loadAsync(
      this.excelFile,
      function (workbook) {
        // user can access the loaded workbook instance in this callback.
        //  self.loading = false;
        self.showLoader = false;
        self.isFileLoaded = true;
      },
      function (reason) {
        console.log("The reason of load failure is " + reason);
        self.showLoader = false;
        self.excelLoadError = 'Unable to load the Excel file.';
      }
    );
  }

  initializeFlexSheet(flex: wjcSheet.FlexSheet) {
    flex.deferUpdate(() => {
      if (flex) {
        flex.selectedSheetIndex = 0;
        flex.isReadOnly = false;
        // flex.allowResizing = 3;
        // flex.allowSorting = false;
        // flex.enableDragDrop = false;
        // flex.refreshOnEdit = false;
        // flex.autoSizeMode = 3;
        flex.allowAddNew = false;
        flex.lazyRender = false;
        flex.showSelectedHeaders = 0;
      }
    });
    this.utilService.updateExcelSheetSelectionExtractionOutput.subscribe((data) => {
      if(data && data.sheetName && data.uuid && this.flex.hostElement && this.flex.hostElement.dataset && this.flex.hostElement.dataset.uuid !== data.uuid) {
        this.flex.selectedSheetIndex  = data.sheetIndex;
        if(data.sheetName && this.flex && this.flex.sheets) {
          const sheetIndex = this.flex.sheets.findIndex(s => s.name === data.sheetName);
          if(sheetIndex >= 0) {
            this.flex.selectedSheetIndex = sheetIndex;
          }
        }
      }
    });
  }

}
